import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-date-field]";
const PLUGIN_NAME = "dateField";

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "date-field" */ "./date-field"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/date-field/index--split.js